
define('text!modules/error/error_template.html',[],function () { return '<p><%- message %></p>';});

